import {
	checkCF,
	validateIBAN
} from '../../utils/commonFormsHandlers';

const GENERAL_STRING_LENGTH = 50;
const CONV_CARD_NUMBER_LENGTH = 20;
const CF_LENGTH = 16;
const MIN_VAT_NUMBER_LENGTH = 5;
const VAT_NUMBER_LENGTH = 11;
const VAT_NUMBER_GENERIC_LENGTH = 14;
const SDI_CODE_LENGTH = 7;
const PHONE_LENGTH = 15;
const MAX_PLATE_LENGTH = 15;
const MAX_STREET_NUMBER_LENGTH = 10;
const PROVINCE_LENGTH = 2;
const CAP_LENGTH = 8;
const IBAN_CODE_LENGTH = 34;
const BANK_ACCOUNT_LENGTH = 50;
const SWIFT_CODE_LENGTH = 11;

const v_required = (value, t) => value ? undefined : t('form.validation.required');
const v_cf_2 = (value, t) => checkCF(value) ? undefined : t('form.validation.cf');
const v_email = (value, t) => value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? t('form.validation.email') : undefined;
const v_vat_number_length = (value, t) => !value || value.length === VAT_NUMBER_LENGTH ? undefined : t('form.validation.piva');
const v_vat_number_length_2 = (value, t) => !value || (value.length >= MIN_VAT_NUMBER_LENGTH && value.length <= CF_LENGTH) ? undefined : t('form.validation.companyCf');
const v_sdi_length = (value, t) => !value || value.length === SDI_CODE_LENGTH ? undefined : t('form.validation.sdi');
const v_province_length = (value, t) => value.length === PROVINCE_LENGTH ? undefined : t('form.validation.province');
const v_iban = (value, t) => validateIBAN(value) ? undefined : t('form.validation.iban');

const n_emailchar = (value, previousValue) => /^[a-zA-Z._%+-@]*$/i.test(value) ? value : previousValue;
const n_onlyalfa = (value, previousValue) => /^[a-zA-Z0-9àáèéìíòóùúÀÁÈÉÌÍÒÓÙÚ\s]*$/i.test(value) ? value : previousValue;
const n_onlyalfa_special = (value, previousValue) => /^([A-Za-z0-9\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\u0021-\u002f\u003A-\u0040\u005B-\u0060\u007B-\u007E\s]*)$/i.test(value) ? value : previousValue;
const n_onlychar = (value, previousValue) => /^[a-zA-ZàáèéìíòóùúÀÁÈÉÌÍÒÓÙÚ.\s]*$/i.test(value) ? value : previousValue;
const n_onlydigit = (value, previousValue) => /^[0-9\s]*$/i.test(value) ? value : previousValue;

const n_general = (value, previousValue) => value.length <= GENERAL_STRING_LENGTH ? value : previousValue;
const n_conv_card_number = (value, previousValue) => value.length <= CONV_CARD_NUMBER_LENGTH ? value : previousValue;
const n_cf_length = (value, previousValue) => value.length <= CF_LENGTH ? value : previousValue;
const n_phone = (value, previousValue) => /^[+]?[0-9]*$/i.test(value) && value.length <= PHONE_LENGTH ? value : previousValue;
const n_plate_length = (value, previousValue) => value.length <= MAX_PLATE_LENGTH && /^[0-9a-zA-Z-\s]*$/i.test(value) ? value : previousValue;
const n_vat_number = (value, previousValue) => value.length <= VAT_NUMBER_LENGTH && /^[0-9]*$/i.test(value) ? value : previousValue;
const n_vat_number_generic = (value, previousValue) => value.length <= VAT_NUMBER_GENERIC_LENGTH && /^[0-9a-zA-Z]*$/i.test(value) ? value : previousValue;
const n_sdi_code = (value, previousValue) => value.length <= SDI_CODE_LENGTH && /^[a-zA-Z0-9àáèéìíòóùúÀÁÈÉÌÍÒÓÙÚ]*$/i.test(value) ? value : previousValue;
const n_street_number_length = (value, previousValue) => value.length <= MAX_STREET_NUMBER_LENGTH ? value : previousValue;
const n_province = (value, previousValue) => value.length <= PROVINCE_LENGTH && /^[a-zA-Z]*$/i.test(value) ? value : previousValue;
const n_cap_length = (value, previousValue) => value.length <= CAP_LENGTH && /^[0-9a-zA-Z-\s]*$/i.test(value) ? value : previousValue;
const n_iban_length = (value, previousValue) => value.length <= IBAN_CODE_LENGTH && /^[a-zA-Z0-9]*$/i.test(value) ? value : previousValue;
const n_bank_account_length = (value, previousValue) => value.length <= BANK_ACCOUNT_LENGTH && /^[a-zA-Z0-9]*$/i.test(value) ? value : previousValue;
const n_swift_length = (value, previousValue) => value.length <= SWIFT_CODE_LENGTH && /^[a-zA-Z0-9]*$/i.test(value) ? value : previousValue;

export {
	v_required,
	v_cf_2,
	v_email,
	v_vat_number_length,
	v_vat_number_length_2,
	v_sdi_length,
	v_province_length,
	v_iban,
	n_emailchar,
	n_onlyalfa,
	n_onlyalfa_special,
	n_onlychar,
	n_onlydigit,
	n_general,
	n_conv_card_number,
	n_cf_length,
	n_phone,
	n_plate_length,
	n_vat_number,
	n_vat_number_generic,
	n_sdi_code,
	n_street_number_length,
	n_province,
	n_cap_length,
	n_iban_length,
	n_bank_account_length,
	n_swift_length
};
